import { format } from "date-fns";
import { useEffect, useState } from "react";

import { Data } from "../constants/data";

export const Timeline: React.FC<{ data: Data }> = ({ data }) => {
  const [expanded, setExpanded] = useState(false);

  const [timeline, setTimeline] = useState<Data["timeline"]>([]);
  useEffect(() => {
    const timelineCopy = [...data.timeline];
    setTimeline(timelineCopy.reverse());
  }, [data.timeline]);

  return (
    <div className="px-4 pb-20 lg:px-0">
      <div className="flex items-center gap-4 pt-8 pb-3">
        <h1 className="text-2xl font-bold font-title">Timeline</h1>

        <button
          className="p-2 font-sans font-bold tracking-wider text-blue-800"
          onClick={() => setExpanded((p) => !p)}
        >
          {expanded ? "collapse" : "expand"}
        </button>
      </div>
      {timeline.map((event, i) => {
        return (
          <div
            className="grid"
            key={`${i}-event-${event.title}-${event.date.toISOString()}`}
            style={{ gridTemplateColumns: "10px 1fr" }}
          >
            <div className="relative h-full lg:ml-6">
              <div className="h-full bg-gray-900" style={{ width: 3 }} />
              <div
                className="absolute bg-gray-900 rounded-full top-1/2"
                style={{ height: 10, width: 10, left: -4 }}
              />
            </div>
            <div
              id="event"
              className={`${
                expanded ? "py-10" : "py-2"
              } pl-4 lg:pl-12 transition-all break-words break`}
              style={{ wordBreak: "break-word" }}
            >
              <span className="font-semibold text-gray-900">
                {format(event.date, "MMM dd, yyyy")}
              </span>
              <h3 className="font-title">{event.title}</h3>
              <div
                className={`text-gray-600 ${
                  expanded ? "mt-4" : "h-0 overflow-y-hidden"
                }`}
              >
                {event.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
